import { createAction, makeActionTrackable } from '@lingoda/core';

interface Payload {
    moduleId: number;
    clearCache?: boolean;
}

export default makeActionTrackable(createAction<Payload>('student/SET_MODULE'));
